import { createAsyncThunk } from '@reduxjs/toolkit';
import apiConfig from 'constants/apiConfig';
import { fetchDiscoveredCreator } from 'services/api/creators';
import { AuthState } from 'slices/auth/reducer';
import { ERROR } from 'types';
import { CreatorDiscoveryReducerState, DiscoveredCreatorItem } from 'types/creator-discovery';
import { getErrorMessage, isFresh } from 'utils/helpers';

export const fetchDiscoveredCreatorThunk = createAsyncThunk<
    { discoveryId: string; socialAccountId: string; creator: DiscoveredCreatorItem },
    { discoveryId: string; socialAccountId: string; force?: boolean },
    { rejectValue: string }
>(
    'creatorDiscovery/creator',
    async ({ discoveryId, socialAccountId, force = false }, { getState, rejectWithValue }) => {
        try {
            const state = getState() as { auth: AuthState; creatorDiscovery: CreatorDiscoveryReducerState };
            const agencyId = state.auth.selectedAgencyId;
            if (!agencyId) throw new Error('No agency selected!');

            const STALE_TIME = apiConfig.FETCH_DISCOVERED_CREATOR.staleTime;
            const lastFetchedAt = state.creatorDiscovery.creator?.[discoveryId]?.[socialAccountId]?.last_fetched_at ?? null;
            if (!force && isFresh(lastFetchedAt, STALE_TIME)) {
                return rejectWithValue(ERROR.CACHED);
            }

            const creator = await fetchDiscoveredCreator(agencyId, discoveryId, socialAccountId);
            return { discoveryId, socialAccountId, creator };
        } catch (error) {
            return rejectWithValue(getErrorMessage(error, 'Failed to fetch discovered creator'));
        }
    }
);
